import React from 'react';
import { OPERATIONAL_STATES } from 'constants/states';
import { browserRedirect } from 'utils/window';

import PPQForm from './components/PPQForm';
import PPQIntro from './components/PPQIntro';
import { toURLParams } from './utils/ppqDataUtils';
import { trackPPQData } from './utils/ppqTrackRequest';

import './PPQ.scss';

const PPQController = ({ partnerName, inviteLink, partnerResultURL }) => {
  const handleGoToResult = (paramData, negativeParamData) => {
    const outcomeURLPath = `${partnerResultURL}outcome?result=${paramData}`;
    if (paramData === 'qualified') {
      browserRedirect(`${outcomeURLPath}&invite_link=${encodeURIComponent(inviteLink)}`);
    } else {
      browserRedirect(`${outcomeURLPath}&${toURLParams(negativeParamData)}`);
    }
  };

  const handleNegativeOutcomeParams = (formData, formResults) => {
    const formResultKeys = Object.keys(formResults);
    const negativeFormResultKeys = formResultKeys.filter((id) => {
      return formResults[id] === false;
    });

    const negativeFormResultData = Object.keys(formData)
      .filter((key) => negativeFormResultKeys.includes(key))
      .reduce((obj, key) => {
        obj[key] = formData[key];
        return obj;
      }, {});

    return negativeFormResultData;
  };

  const handlePPQResult = (formData) => {
    const formResults = {};
    //Checking if the state is operational
    formResults.state = OPERATIONAL_STATES.includes(formData.state);
    //Checking homeowner's credit score
    formResults.credit_score = !['Below 500', '501 to 600'].includes(formData.credit_score);
    //Checking homeowner's property type
    formResults.property_type = !['multi 5 plus', 'co-op'].includes(formData.property_type);
    //Checking late mortgage balance
    formResults.mortgage_balance = 1 - formData.mortgage_balance / formData.home_value < 0.25 ? false : true;
    //Checking late mortgage payments
    formResults.num_late_payments = formData.num_late_payments > 3 ? false : true;
    //Checking if homeowner has experienced foreclosure
    formResults.foreclosure = formData.foreclosure !== 'yes';
    //Checking if homeowner has filed for bankruptcy
    formResults.bankruptcy = formData.bankruptcy !== 'yes';

    formData.partner_name = partnerName;
    const finalPPQResult = Object.keys(formResults).every((key) => {
      return formResults[key] === true;
    });
    const negativeOutcomeParams = handleNegativeOutcomeParams(formData, formResults);
    const output = finalPPQResult ? 'qualified' : 'not-qualified';

    trackPPQData(formData, output).finally(() => {
      handleGoToResult(output, negativeOutcomeParams);
    });
  };

  return (
    <div className="PPQController">
      <PPQIntro />
      <div className="PPQFormWrapper">
        <PPQForm onSubmit={handlePPQResult} />
      </div>
    </div>
  );
};

export default PPQController;
